export type UserType =
    | 'IS_PARENT'
    | 'IS_TEACHER'
    | 'IS_ADMIN_TEACHER'
    | 'IS_PENDING_TEACHER'
    | 'IS_GLOBAL_ADMIN'
    | 'OTHERS'

/* eslint-disable */
export enum UserTypes {
    IS_PARENT = 'IS_PARENT',
    IS_TEACHER = 'IS_TEACHER',
    IS_ADMIN_TEACHER = 'IS_ADMIN_TEACHER',
    IS_PENDING_TEACHER = 'IS_PENDING_TEACHER',
    IS_GLOBAL_ADMIN = 'IS_GLOBAL_ADMIN',
    OTHERS = 'OTHERS'
}
/* eslint-enable */

export type UserLoginInput = {
    email: string
    password: string
}

export type LoginResponse = {
    login: {
        _id: string
        auth0UserId: string
        accessToken: string
    }
}

export type UserProfile = {
    _id: string
    firstName: string
    lastName: string
    auth0UserId: string
    email: string
    isTeacher: boolean
    picture?: string
    imageUrl?: string
    parent?: {
        _id: string
        phoneNumber: string
        relationship: string
        branch: {
            _id: string
            name: string
        }
    }
    roles: Array<{
        _id: string
        language: string
        name: string
        permissions: Array<{
            _id: string
            name: string
        }>
    }>
    /** Flat permission strings from the central system (e.g. 'sudo'). */
    permissions?: string[]
    userTypes: UserTypes[]
}

export type AuthContextType = {
    user: UserProfile | null
    isAuthenticated: boolean
    isLoading: boolean
    /*eslint no-unused-vars: ["error", { "args": "none" }]*/
    login: (email: string, password: string) => Promise<void>
    logout: () => Promise<void>
    refreshProfile: () => Promise<void>
    userTypes: UserTypes[] | null
    isType?: (type: UserType) => boolean
}
